export default {
  "HitPaw Online Audio Extractor": "音訊提取",
  "Extract sound from videos with ease.": "提取影片中的聲音",
  "Select Audio Format": "選擇音訊格式",
  "Extract Audio": "提取音訊",
  "Extracting Audio": "音訊提取中",
  "Extracted Successfully": "提取成功",
  "Extract New": "提取新檔案",
  "Extraction Failed": "提取失敗",
  "Format": "格式",
};
